import React from 'react';
import PropTypes from 'prop-types';
import TimeElapsed from './TimeElapsed';
import Button from './Button';
import HelpPanel from './HelpPanel';
import CompletedScreen from './CompletedScreen';
import GameSurface from './GameSurface';
import './../assets/css/styles.scss';
import data from './data';
import ScrollMagic from 'scrollmagic';
import InitialState from './InitialState';


require('animation.gsap');
require('debug.addIndicators');
class FiftyStatesGame extends React.Component {   

    constructor(props){
        super(props);
        this.play = this.play.bind(this);
        this.complete = this.complete.bind(this);
        this.reset = this.reset.bind(this);
        this.resize = this.resize.bind(this);
        this.data = data;
        this.state = {
            time : 0,
            play : false,
            completed : false,
            help : false,
            start : null
        }
        this.controller = new ScrollMagic.Controller({
            addIndicators : false
        });

    }

    resize(){
        // if(this.timer) {window.clearInterval(this.timer)};
        // this.setState({
        //     play : false,
        //     time : 0,
        //     completed : false
        // })
        // this.gameSurface.resetGame();
        // this.timer.reset();
        // this.initial.show();
    }

    componentWillMount(){ }
    
    componentDidMount(){
        // this.gameSurface.startGame();
        window.addEventListener('resize', this.resize);
    }

    componentWillUnmount(){
        window.removeEventListener('resize', this.resize);
    }

    play(){
        if(this.state.play){
            //stop the timer
            this.timer.pause();
        } else {
            this.timer.start();
            this.gameSurface.startGame();
            this.setState({play : true})
            this.initial.hide();
            
        }
    }
    complete(){
        this.timer.pause();
        this.setState({
            play : false,
            completed : true
        })
    }

    reset(){
        this.timer.reset();
        this.setState({completed : false, play : false, time: 0});
        this.gameSurface.resetGame();
        this.initial.show();
    }
    

    render(){
        return (
            <div className="FiftyStatesGame">
                <p>FiftyStatesGame</p>
            </div>
        )
    }
    render(){

        const renderStart = ()=>{
            if(this.state.play) return (
                <div key="playbutton">
                    <Button style={{marginBottom:5}}   color="#5597B8" onClick={()=>{this.setState({help : true})}}>HOW TO PLAY</Button>
                    <Button  color="#822C30" onClick={this.reset}>RESET GAME</Button>
                </div>
            );
            return(
                <div key="playbutton">
                    <Button style={{marginBottom:5}}   color="#5597B8" onClick={()=>{this.setState({help : true})}}>HOW TO PLAY</Button>
                    <Button  color="#822C30" onClick={this.play}>START GAME</Button>
                </div>
            )
        }
        return (
            <div className="FiftyStatesGame">
                <p className="instruction-title">Test Your Knowledge: State Capitals</p>
                <p className="instruction">There are 50 U.S. state capitals, but can you name them correctly? Take our quiz to test just how well you know the United States. Hit "start game" to play against the clock and see how long it takes you to name all 50. Good luck!</p>
                <div className="FiftyStatesGame-Wrap">
                    <InitialState controller={this.controller} ref={(node)=>this.initial=node} active={!this.state.play}></InitialState>
                    
                    <GameSurface ref={(node)=>{this.gameSurface = node;}} data={this.data} onSelect={this.stickSelect} play={this.state.play} onComplete={this.complete}></GameSurface>
                    <TimeElapsed ref={(node)=>this.timer=node} active={this.state.play} onChange={(time)=>{this.setState({time:time})}} time={this.state.time}></TimeElapsed>
                    <div className={(this.state.play)?'buttonPanel active': 'buttonPanel'}>
                        {renderStart()}    
                    </div>
                    <HelpPanel visible={this.state.help} onClose={()=>{this.setState({help : false})}}></HelpPanel>
                    <CompletedScreen time={this.state.time} visible={this.state.completed} onReset={this.reset}></CompletedScreen>
                    
                </div>
               
                
                <style jsx>{`
                    .FiftyStatesGame {
                        max-width: 700px;
                        margin:auto!important;
                    }        


                    .FiftyStatesGame-Wrap {
                        position: relative;
                        padding-bottom: 100px!important;
                    }
                    
                    .buttonPanel {
                        
                        position: absolute;
                        bottom:10px;
                    }
                    .instruction-title {
                        font-weight:400!important;
                        font-size:22px!important;
                        border-bottom:1px solid #3B5A78!important;
                        margin-bottom:20px!important;
                        color:#3B5A78!important;
                    }
                    .instruction {
                        font-weight:400!important;
                        font-size:18px!important;
                        margin-bottom:40px!important;
                    }
                    @media all and (max-width:599px){
                        .FiftyStatesGame-Wrap {
                            padding-bottom: 0px!important;
                            min-height: 55vw;
                        }
                        .buttonPanel {
                            position: relative;
                            margin-top:20px!important;
                        }
                    
                    }

                    

                    
                `}</style>
                    <style jsx global>{`
                        
                        #FiftyStatesGame .HelpPanel,#FiftyStatesGame .CompletedScreen{z-index:1;}
                        @media all and (max-width:768px){
                            #FiftyStatesGame .HelpPanel,#FiftyStatesGame .CompletedScreen{z-index:10;}
                            
                        }
                    `}</style>
            </div>
        )
    }
}

FiftyStatesGame.propTypes = {
    
}

export default FiftyStatesGame;